import { Card as CardType, DareTypes } from "../types";

interface DareCard extends CardType {
  activity: DareTypes | "other";
}

export const DARE_CARDS: DareCard[] = [
  {
    description: "The person to your left must give you a hickey on your neck.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person to your left must suck on your earlobe for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person opposite you must suck on your finger for 10 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person to your right must suck on your toe for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
    pub: true,
  },

  {
    description:
      "The person opposite you must suck on your belly button for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person to your left must grind against your thigh for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person opposite you must grind against your leg for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person to your right must grind against your foot for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person 2 places to your left must grind against your arm for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person opposite you must grind against your hand for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person to your left must rub their pussy/dick against your thigh for 10 seconds.",
    penaltyCost: 5,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person opposite you must rub their pussy/dick against your leg for 10 seconds.",
    penaltyCost: 5,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person to your right must rub their pussy/dick against your foot for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person 2 places to your left must rub their pussy/dick against your arm for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person opposite you must rub their pussy/dick against your hand for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
  },
  {
    genre: "dare",
    activity: "kiss",
    pub: true,
    description:
      "Spin the bottle. Whoever it lands on, you must kiss them passionately for 10 seconds.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "dance",
    description:
      "Spin the bottle. Whoever it lands on, you must give them a lap dance for 30 seconds.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "sexy",
    pub: true,
    description:
      "Spin the bottle. Whoever it lands on, you must make out with them for 15 seconds.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "touch",
    pub: true,
    description:
      "Spin the bottle. Whoever it lands on, you must give them a hickey on their neck.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "touch",
    pub: true,
    description:
      "Spin the bottle. Whoever it lands on, you must give them a sensual massage for 30 seconds.",
    penaltyCost: 4,
  },
  {
    description: "Go outside and try to do a cartwheel. No adding any clothes.",
    penaltyCost: 4,
    genre: "dare",
    activity: "action",
  },
  {
    description:
      "Button up! Eat a chocolate button off the person opposite's belly button.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
    pub: true,
  },
  {
    description:
      "Button up! Eat a chocolate button off the person to your left's boob.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "Button up! Eat a chocolate button off the person to your right's neck.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "Button up! Eat a chocolate button off the person 2 places to your left's boob.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "Button up! Eat a chocolate button off the person 4 places to your right's thigh.",
    penaltyCost: 4,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "Button up! Eat a chocolate button off the person opposite's lower back.",
    penaltyCost: 4,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "Button up! Eat a chocolate button off the person to your left's thigh.",
    penaltyCost: 2,
    genre: "dare",
    activity: "eat",
    pub: true,
  },
  {
    description:
      "Button up! Eat a chocolate button off the person to your right's thigh.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
    pub: true,
  },

  {
    description: "Shoey! Drink some of your drink from your shoe.",
    penaltyCost: 5,
    genre: "dare",
    activity: "drink",
    pub: true,
  },
  {
    description: "Shoey! Drink some of your drink from the closest shoe.",
    penaltyCost: 5,
    genre: "dare",
    activity: "drink",
    pub: true,
  },

  {
    description:
      "You have 10 seconds to lick a different body part of each player. Timer resets after each lick.",
    penaltyCost: 5,
    genre: "dare",
    activity: "lick",
    pub: true,
  },
  {
    description:
      "Pour their drink into your mouth, then you waterfall it back to them",
    penaltyCost: 3,
    genre: "dare",
    activity: "drink",
    pub: true,
  },
  {
    description:
      "The person opposite you must take a shot from your mouth, then you take one from theirs.",
    penaltyCost: 3,
    genre: "dare",
    activity: "drink",
    pub: true,
  },
  {
    description:
      "Drag an ice cube down your body, then let the person opposite you lick it off.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Use your teeth to drag an ice cube down the person opposite you's belly then lick it off.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Find a partner, transfer an ice cube from mouth to mouth. The number of swaps is a penalty dished out to the whole group.",
    penaltyCost: 3,
    genre: "dare",
    activity: "partner",
    pub: true,
  },
  {
    description:
      "The person opposite you must lick your belly button for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Lick the inner thigh of the person opposite you for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your left must drag an ice cube down your back, then lick it off.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person opposite you must put an ice cube in their mouth and kiss you until it melts.",
    penaltyCost: 4,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "The person to your right must drag an ice cube down your inner thigh, then lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 2 places to your left must put an ice cube in their cleavage, then you must retrieve it with your mouth.",
    penaltyCost: 3,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person opposite you must drag an ice cube down your chest, then lick it off.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your right must put an ice cube in their mouth and kiss you passionately until it melts.",
    penaltyCost: 5,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "The person 3 places to your left must drag an ice cube down your stomach, then lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person opposite you must put an ice cube in their belly button, then you must retrieve it with your tongue.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person to your left must drag an ice cube down your neck, then lick it off.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 2 places to your right must put an ice cube in their mouth and kiss you deeply until it melts.",
    penaltyCost: 4,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "The person opposite you must drag an ice cube down your arm, then lick it off.",
    penaltyCost: 2,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your right must put an ice cube in their cleavage, then you must retrieve it with your tongue.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person 3 places to your left must drag an ice cube down your leg, then lick it off.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person opposite you must put an ice cube in their mouth and kiss you with tongue until it melts.",
    penaltyCost: 4,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "The person to your left must drag an ice cube down your back, then lick it off while kissing your neck.",
    penaltyCost: 5,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person opposite you must give you a hickey on your inner thigh.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "On GO! Everyone swap an item of underwear with the person to your left. Last person finishes their drink.",
    penaltyCost: 4,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Eat a pube off (using your teeth) the person to your left.",
    penaltyCost: 5,
    genre: "dare",
    activity: "eat",
  },
  {
    description: "Eat a provided pube hair from the person to your left.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "The person to your left must give you a quick peck on the cheek.",
    penaltyCost: 1,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description: "The person opposite you must pinch your arm for 3 seconds.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "The person to your right must flash their shoulder at you.",
    penaltyCost: 1,
    genre: "dare",
    activity: "sexy",
    pub: true,
  },
  {
    description:
      "The person to your left must give you a quick bite on the shoulder.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "The person opposite you must flick your nose 3 times.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "The person to your right must rub your arm for 10 seconds.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person 2 places to your left must kiss your neck for 5 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description: "The person opposite you must pinch your thigh for 5 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
    pub: true,
  },

  {
    description:
      "The person 2 places to your left must bite your neck for 5 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "The person opposite you must flick your ear 5 times.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person 3 places to your left must kiss your collarbone for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "The person opposite you must pinch your nipple for 5 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "The person to your right must flash their cleavage at you.",
    penaltyCost: 3,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person 2 places to your right must kiss your inner thigh for 15 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "The person opposite you must pinch and twist your nipple for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "The person to your right must flash their pussy/dick at you.",
    penaltyCost: 4,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "The person 3 places to your right must kiss your pussy/dick through your clothes.",
    penaltyCost: 5,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "The person opposite you must pinch your clit/dick for 10 seconds.",
    penaltyCost: 5,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "The person to your left must lick your cheek for 3 seconds.",
    penaltyCost: 1,
    genre: "dare",
    activity: "lick",
    pub: true,
  },
  {
    description: "The person opposite you must lick your neck for 5 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "lick",
    pub: true,
  },
  {
    description:
      "The person to your right must lick your collarbone for 10 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 2 places to your left must lick your nipple for 10 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person opposite you must lick your inner thigh for 15 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your right must lick your pussy/dick through your clothes.",
    penaltyCost: 5,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your left must give you a quick spank on the ass.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "The person to your right must spank your ass 10 times.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person 2 places to your left must spank your pussy/dick 10 times.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person opposite you must spank your ass until it turns red.",
    penaltyCost: 5,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person to your right must give you a quick tickle on your sides.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person opposite you must tickle your feet for 10 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person to your left must tickle your inner thighs for 15 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "The person 2 places to your right must tickle your pussy/dick through your clothes.",
    penaltyCost: 4,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "The person to your left must give you a quick massage on your shoulders.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person opposite you must massage your back for 30 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person to your right must massage your thighs for 30 seconds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "The person 2 places to your left must massage your pussy/dick through your clothes.",
    penaltyCost: 4,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "The person opposite you must massage your asshole through your clothes.",
    penaltyCost: 5,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "The person to your left must pour their drink into your mouth, then kiss you to transfer it back.",
    penaltyCost: 2,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "The person opposite you must take a shot, then kiss you to transfer it to your mouth.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "The person to your right must pour their drink into your mouth, then kiss you deeply to transfer it back.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "The person 2 places to your left must take a shot, then kiss you passionately to transfer it to your mouth.",
    penaltyCost: 4,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },

  {
    description:
      "The person to your left must pour their drink into your mouth, then kiss you passionately to transfer it back.",
    penaltyCost: 5,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "Give a lap dance to the person on your left. Must be at least 30 seconds.",
    penaltyCost: 4,
    genre: "dare",
    activity: "dance",
  },
  {
    description:
      "Strip down to your underwear and do a runway walk through the room.",
    penaltyCost: 5,
    genre: "dare",
    activity: "sexy",
  },
  {
    description:
      "Wear a pair of someone else's underwear on your head for the next 3 rounds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "action",
  },
  {
    description:
      "The person to your right must squirt whipped cream on your nipple and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Do a dramatic reading of your most recent text messages to the group.",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
  },
  {
    description:
      "The person 3 places to your left must squirt ketchup on your belly button and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your right must draw a smiley face on your butt with permanent marker.",
    penaltyCost: 5,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person 4 places to your left must squirt chocolate sauce on your nipple and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your left must draw a heart on your chest with lipstick.",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person 2 places to your right must squirt honey on your belly button and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 3 places to your right must draw a star on your forehead with eyeliner.",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person to your left must squirt mustard on your nipple and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 5 places to your right must draw a flower on your thigh with permanent marker.",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person 4 places to your left must squirt maple syrup on your belly button and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person to your right must draw a sun on your back with permanent marker.",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person 2 places to your left must squirt BBQ sauce on your nipple and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 3 places to your right must draw a moon on your cheek with permanent marker.",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person to your left must squirt mayo on your belly button and lick it off.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "The person 4 places to your right must draw a rainbow on your arm with permanent marker.",
    penaltyCost: 3,
    genre: "dare",
    activity: "draw",
  },

  {
    description:
      "Untested science? Squirt bbq sauce on the nipple to the left. Lick it off.",
    penaltyCost: 5,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "For science? Squirt BBQ sauce on the first balls available to the right. Lick it off them after.",
    penaltyCost: 5,
    genre: "dare",
    activity: "lick",
  },
  {
    description: "Exchange an item of clothing with the closest person.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },

  {
    description:
      "Exchange an item of clothing with the person directly opposite.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Exchange an item of clothing with the person on your left.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Exchange an item of clothing with the person on your right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Exchange an item of clothing with the person 3 to your left.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Exchange an item of clothing with the person 4 to your left.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Exchange an item of clothing with the person 3 to your right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Exchange an item of clothing with the person 4 to your right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Remove 1 item of clothing.",
    penaltyCost: 1,
    genre: "dare",
    activity: "clothes",
  },

  {
    description: "Remove 2 items of clothing.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Remove 3 items of clothing.",
    penaltyCost: 3,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Remove 4 items of clothing.",
    penaltyCost: 4,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Remove 5 items of clothing.",
    penaltyCost: 5,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Put on 1 piece of the nearest clothes",
    penaltyCost: 1,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Put on 2 pieces of the nearest clothes",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Put on 3 pieces of the nearest clothes",
    penaltyCost: 3,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Put on 4 pieces of the nearest clothes",
    penaltyCost: 4,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Put on 5 pieces of the nearest clothes",
    penaltyCost: 5,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "The group decides something to draw on you. (You can pick where it goes).",
    penaltyCost: 2,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The closest person decides something to draw on you. (You can pick where it goes).",
    penaltyCost: 2,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person directly opposite decides something to draw on you. (You can pick where it goes).",
    penaltyCost: 2,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The group decides something to draw on you. (They pick where it goes).",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The closest person decides something to draw on you. (They pick where it goes).",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description:
      "The person directly opposite decides something to draw on you. (They pick where it goes).",
    penaltyCost: 4,
    genre: "dare",
    activity: "draw",
  },
  {
    description: "The group makes you a mystery drink.",
    penaltyCost: 5,
    genre: "dare",
    activity: "drink",
  },
  {
    description:
      "The closest person decides to like an old insta picture for you.",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description:
      "The closest person decides to reply to an insta story for you.",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description:
      "The group picks something for you to eat without using your hands.",
    penaltyCost: 2,
    genre: "dare",
    activity: "eat",
  },
  {
    description: "Twerk for the group",
    penaltyCost: 1,
    genre: "dare",
    activity: "dance",
  },
  {
    description: "Give the group the best magic mike performance.",
    penaltyCost: 2,
    genre: "dare",
    activity: "dance",
  },
  {
    description: "Dance without music for 1 minute.",
    penaltyCost: 1,
    genre: "dare",
    activity: "dance",
  },

  {
    description:
      "The person on the left finds any amazon product, shares the link to it with a random DM.",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: 'Update your facebook status to "Engaged".',
    penaltyCost: 4,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description:
      "Message your sibling/parent that you are, or have got someone, pregnant.",
    penaltyCost: 4,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: "Give the group your best orgasm face and sounds.",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: 'Message your ex "I miss you".',
    penaltyCost: 5,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: "Let everyone else write something on your body.",
    penaltyCost: 2,
    genre: "dare",
    activity: "draw",
  },
  {
    description: "Moon the group",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
  },
  {
    description: 'The group decides who to message: "Wanna have a threesome?" ',
    penaltyCost: 4,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: 'The person on your left writes "Slut" on your chest.',
    penaltyCost: 3,
    genre: "dare",
    activity: "draw",
  },
  {
    description: "Suck the person furthest aways toes.",
    penaltyCost: 5,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Get the person 3 places to the left give you a love bite.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Give the person opposite a kiss on the cheek.",
    penaltyCost: 1,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description: "Give the person to the left a kiss on their elbow.",
    penaltyCost: 1,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description:
      "Get the person 3 places to the right to spit a shot into your mouth.",
    penaltyCost: 4,
    genre: "dare",
    activity: "drink",
    pub: true,
  },
  {
    description:
      "Get the person 2 places to the left to sit on your lap until their go.",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description:
      "Seductively suck on the person 5 places to the rights finger.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "Let the person to your left spank you.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Have the person 4 places to the left slap your ass.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Recreate a sex position with the person 5 places to the right.",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
  },
  {
    description: "Recreate doggystyle with the person to your right.",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
  },
  {
    description:
      "Message your sibling/parent your phones 10th photo without context.",
    penaltyCost: 2,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: "Let everyone pinch your nipples.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Let the person 4 places to the left slap you.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Give the person opposite a lapdance.",
    penaltyCost: 3,
    genre: "dare",
    activity: "dance",
  },
  {
    description: "Unzip the first zip you can see with your mouth.",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
  },
  {
    description: "Lick the person to the rights belly button.",
    penaltyCost: 5,
    genre: "dare",
    activity: "lick",
  },
  {
    description: "Kiss the person to the lefts belly button.",
    penaltyCost: 5,
    genre: "dare",
    activity: "kiss",
  },
  {
    description: "Demonstrate oral on the nearest object.",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description:
      "Get the person 2 places to the left to ride you around the room.",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
  },
  {
    description: "Lick mayo off the closest person (You pick the body part)",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Lick whipped cream off the person 6 places to the right (You pick the body part)",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Lick mayo off the person 3 places to the right (closest person (Group picks the body part)",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Lick whipped cream off the 2 places to the right (Group picks the body part)",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "While blindfolded, the group decides someone for you to lapdance.",
    penaltyCost: 3,
    genre: "dare",
    activity: "dance",
  },
  {
    description:
      "While blindfolded, the group decides someone and somewhere for you to kiss.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "While blindfolded, the group decides 3 objects for you to kiss.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "Wear your underwear on the outside of your clothes for the rest of the game.",
    penaltyCost: 5,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Creatively drink a shot off the body of the person furthest away.",
    penaltyCost: 5,
    genre: "dare",
    activity: "drink",
  },
  {
    description: "Crawl under the legs of the person to the right.",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Spoonfull of the groups choice of condiment.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description: "Give the person 6 places to your right a lapdance.",
    penaltyCost: 4,
    genre: "dare",
    activity: "dance",
  },
  {
    description: "Give the person 4 places to your right a lapdance.",
    penaltyCost: 4,
    genre: "dare",
    activity: "dance",
  },
  {
    description:
      "Pass a card using your mouth to the person 4 places to the left.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
  },

  {
    description: "Take a shot without using your hands.",
    penaltyCost: 2,
    genre: "dare",
    activity: "drink",
    pub: true,
  },
  {
    description: "Kiss the person to your left.",
    penaltyCost: 1,
    genre: "dare",
    activity: "kiss",
  },
  {
    description: "Do a sexy crawl along the floor to the person opposite.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
  },
  {
    description:
      "Put on 1 piece of the nearest clothes (From the room, not from on people in the group)",
    penaltyCost: 1,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Put on 2 pieces of the nearest clothes (From the room, not from on people in the group)",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Put on 3 pieces of the nearest clothes (From the room, not from on people in the group)",
    penaltyCost: 3,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Put on 4 pieces of the nearest clothes (From the room, not from on people in the group)",
    penaltyCost: 4,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Put on 5 pieces of the nearest clothes (From the room, not from on people in the group)",
    penaltyCost: 5,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Spin around 10 times and do a shot.",
    penaltyCost: 2,
    genre: "dare",
    activity: "drink",
    pub: true,
  },

  {
    description:
      "Exchange an item of clothing with the person wearing the most.",
    penaltyCost: 1,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Lick the armpit of the person 6 places to your left.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
    pub: true,
  },
  {
    description: "Snort a pinch of black pepper.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Squirt lemon juice in your eye.",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
  },
  {
    description: "Eat a teaspoon of hot sauce.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description: "Lick the inner thigh of the person 2 places to your left.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "You can put all of your original clothes back on (From floor or from others)",
    penaltyCost: 1,
    genre: "dare",
    activity: "clothes",
  },

  {
    description: "Act like a cat to the person to your right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
    pub: true,
  },

  {
    description: "Lick a sauce off the neck of the person to the left.",
    penaltyCost: 2,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Lick whipped cream off chest of the person 6 places to the right.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description:
      "Lick whipped cream off the upper thigh of the person 3 places to the right.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },

  {
    description: "Exchange an item of clothing with the person 6 to your left.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Exchange an item of clothing with the person 6 to your right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },

  {
    description: "Give the person 3 to the left a kiss on the lips.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
  },
  {
    description: "Give the person 3 to the right a kiss on the lips.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description: "Spin the bottle! Kiss.",
    penaltyCost: 2,
    genre: "dare",
    activity: "kiss",
    pub: true,
  },
  {
    description: "Spin the bottle, Seven minutes in heaven.",
    penaltyCost: 5,
    genre: "dare",
    activity: "touch",
  },

  {
    description: "Swap underwear with the person to your right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "clothes",
  },
  {
    description:
      "Transfer an icecube (or snack) from your mouth to the person 5 places to the left.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },

  {
    description: 'Send "Hey, you up?" to your 5th instagram story.',
    penaltyCost: 2,
    genre: "dare",
    activity: "phone",
    pub: true,
  },

  {
    description: "Send a sexy photo to the person 5 places to the left.",
    penaltyCost: 4,
    genre: "dare",
    activity: "phone",
  },
  {
    description: "Lick a nipple of the person to 3 places to the right.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },

  {
    description: "Remove 2 items of clothes and 2 from the person to the left.",
    penaltyCost: 3,
    genre: "dare",
    activity: "clothes",
  },

  {
    description: "Motorboat the person 2 places to the right.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },

  {
    description: "Remove 4 items of clothes and 4 from the person opposite.",
    penaltyCost: 5,
    genre: "dare",
    activity: "clothes",
  },
  {
    description: "Make out with the person 5 to the left.",
    penaltyCost: 5,
    genre: "dare",
    activity: "kiss",
  },

  {
    description:
      "Let the person to your right put duct tape on any part of your body they choose and rip it off.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Sniff the person to the lefts armpit for 10 seconds.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description: "Let the group cut a piece of your hair.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Kiss the person to the right's bum.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
  },

  {
    description: "Try and put your fist in your mouth.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      "While blindfolded, the group decides something for you to kiss.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
  },
  {
    description:
      "While blindfolded, the group decides something for you to lick.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },

  {
    description: "Eat a raw egg",
    penaltyCost: 5,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "While blindfolded, the group decides something for you to suck on.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Facial! Rub a condiment onto your face like a mud mask and leave for 10mins.",
    penaltyCost: 5,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Bite someone elses fingernails.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Bite someone elses toenails.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Yoga time! Show the group your best downward dog, don't forget to bark.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Explain nothing. Loudly start clucking like a chicken.",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description:
      "That's a secret I'll never tell. Xoxo go piss girl. Tell your family you have an std and it burns when you pee.",
    penaltyCost: 4,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: "Do your best armpit fart.",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Pick your nose and eat it.",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
    pub: true,
  },
  {
    description: "Greece lightening! Butter your hair back.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Ever wondered what it's like to be a cow? Now's your chance! Out on the lawn munching grass and mooing.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
  },
  {
    description:
      "Wearing make up? Splash water on your eyes and rub. Not wearing make up? Allow someone to give you the joker look.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Receive a wedgie from the person 3 to your left. Ask them to pull nice and hard please.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Taste the rainbow. Mix 7 colours of drink together and down it.",
    penaltyCost: 5,
    genre: "dare",
    activity: "drink",
  },
  {
    description:
      "Colour me in sunshine. Receive a makeover using whatever is available. The person 3 to your right has 60 seconds. START NOW!",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },

  {
    description:
      "Love bites. We love a tattoo trend, let the person opposite bite down really hard on your arm, then Sharpie the bite mark.",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },

  {
    description:
      "Cream for me. Seductively lick whipped cream off a phallic object.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },

  {
    description:
      'Suck your own toes, or at least attempt it. If you dont make it ask the person next to you in a baby voice "please sir can you lick my ickle toes".',
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
    pub: true,
  },

  {
    description:
      "Don't be shy, ask the person opposite to brush your hair and treat you like a dog. Ruff. Did I mention you can only bark?",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
    pub: true,
  },

  {
    description: "Shotgun a beer",
    penaltyCost: 3,
    genre: "dare",
    activity: "drink",
    pub: true,
  },

  {
    description:
      "It's nice to keep in touch. Message a friend you haven't spoken to in at least 6 months \"Hey cuteness. Sending you a virtual tug\".",
    penaltyCost: 2,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description: "Stroke me... Start seductively rubbing your own crotch.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description:
      "Touch me... Start seductively rubbing your own nipples. Bonus points for facial expressions.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },

  {
    description: "Boop the snoot. Boop everyone in a circle. Make it cute.",
    penaltyCost: 1,
    genre: "dare",
    activity: "touch",
    pub: true,
  },
  {
    description:
      'Tea time! Offer everyone a cuppa and if they accept you make it and act like a Victorian maid "yes ma\'am".',
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
  },
  {
    description:
      'Fluffy bunnies. Shove as much of the nearest food in your mouth at once then say "fluffy bunnies".',
    penaltyCost: 2,
    genre: "dare",
    activity: "eat",
  },
  {
    description:
      "Cuckold. Ask a pair of players to join you in the bathroom stand in the corner and loudly commentate whilst they make out.",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
  },
  {
    description:
      "Rumblies that only hands would satisfy. Nibble and suck on the person 2 to your lefts entire hand. Leave no skin unmunched.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
    pub: true,
  },

  {
    description: "Leave the room and reenter. Put on the best fashion catwalk",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
  },

  {
    description: "Do the exactly the same as the previous card drawn. ",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Do the exactly the same as the previous 2 cards drawn. ",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Do the exactly the same as the previous 3 cards drawn. ",
    penaltyCost: 3,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Do the exactly the same as the previous 4 cards drawn. ",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Do the exactly the same as the previous 5 cards drawn. ",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
    pub: true,
  },

  {
    description: "Try to juggle 3 things of the group's choice.",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
  },
  {
    description: "Pretend to be a food item of the group's choice.",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description: "Eat a raw piece of garlic",
    penaltyCost: 3,
    genre: "dare",
    activity: "eat",
  },
  {
    description: "Do 10 squats.",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
  },

  {
    description: "Put 3 different available liquids into a cup and drink it.",
    penaltyCost: 3,
    genre: "dare",
    activity: "drink",
  },

  {
    description:
      "Stars in their eyes! Sing along to the current music for 30 seconds in front of the group. (Or play music)",
    penaltyCost: 2,
    genre: "dare",
    activity: "act",
  },
  {
    description:
      "Place this card onto the person 2 to the left's crotch without using your hands.",
    penaltyCost: 4,
    genre: "dare",
    activity: "touch",
  },

  {
    description: "Lick the inner thigh of the person to your left.",
    penaltyCost: 4,
    genre: "dare",
    activity: "lick",
  },
  {
    description: "Lick the lower back of the person to your left.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },

  {
    description: "Lick a nipple of the person to the left.",
    penaltyCost: 3,
    genre: "dare",
    activity: "lick",
  },
  {
    description: "Give the person to the left a hickey on their boobs.",
    penaltyCost: 3,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Kiss a nipple of the person to the right.",
    penaltyCost: 3,
    genre: "dare",
    activity: "kiss",
  },

  {
    description: "Kiss 2 nipples from the group. (They pick who)",
    penaltyCost: 5,
    genre: "dare",
    activity: "kiss",
  },

  {
    description: "Flash (tits or ass) to the person to the right.",
    penaltyCost: 4,
    genre: "dare",
    activity: "act",
  },

  {
    description:
      "Roll a D6 3 times. Remove an item of clothing each time it's over 3 ",
    penaltyCost: 3,
    genre: "dare",
    activity: "clothes",
    extras: ["randomNumber"],
  },

  {
    description: "Give a foot massage to the person on your right. ",
    penaltyCost: 2,
    genre: "dare",
    activity: "touch",
  },
  {
    description: "Drink your drink off the chest of the person to the right.",
    penaltyCost: 3,
    genre: "dare",
    activity: "drink",
  },
  {
    description: "Impersonate an animal (Until someone says the name of it)",
    penaltyCost: 1,
    genre: "dare",
    activity: "act",
    pub: true,
  },
  {
    description:
      "Go on Facebook and like 5 photo pictures of the first person you see. ",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
    pub: true,
  },

  {
    description:
      "In your current state, send your best selfie to the person 2 to the right. ",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
    pub: true,
  },
  {
    description:
      "In your current state, send your best selfie to a family member. ",
    penaltyCost: 3,
    genre: "dare",
    activity: "phone",
    pub: true,
  },

  {
    genre: "dare",
    activity: "act",
    description: "Balance a cup on your head for 15 seconds.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Do a sexy runway walk across the room.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Do an imitation of a celebrity hitting on the person 2 to the left.",
    penaltyCost: 2,
    pub: true,
  },
  {
    genre: "dare",
    activity: "touch",
    description:
      "Pick the person 4 to the left to give you a hickey, or take a penalty.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Recreate a steamy movie scene with the person 5 to the right for 30 seconds.",
    penaltyCost: 5,
    pub: true,
  },

  {
    genre: "dare",
    activity: "act",
    description: "Do 10 push-ups while everyone counts out loud.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Post an embarrassing or sexy selfie on your social media for 10 minutes.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "kiss",
    description: "Kiss the person 4 to the left in the group",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "dance",
    description:
      "Give the person 1 to the right in the group a lap dance for 15 seconds.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "draw",
    description:
      "Let the person 6 to the left write a suggestive word or phrase on your body with a marker.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Call someone you've hooked up with and ask them to rate your performance.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "phone",
    description: "Send a risqué text to the third person in your contact list.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "draw",
    description:
      "Let the person 3 to the right draw something filthy on your body with a marker.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Make out with your hand passionately for 15 seconds while maintaining eye contact with the group.",
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Flash the group in a dramatic reveal.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Let the person 4 to the left scroll through your photos for 10 seconds—or take the penalty.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Let the group pick an embarrassing post for you to put on social media for 10 minutes.",
    penaltyCost: 5,
    pub: true,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Swap your top with the person 2 to the right.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Whisper something dirty into the ear of the person to your right.",
    penaltyCost: 1,
    pub: true,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Reenact a steamy scene from a popular movie with the person 6 to the left.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Give the person 2 to the right in the group a 15-second massage, but make it steamy and sensual.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Pretend to fake an orgasm for 10 seconds as loudly and convincingly as possible.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Call someone you've hooked up with and ask, 'Was I good in bed?'",
    penaltyCost: 4,
    pub: true,
  },

  {
    genre: "dare",
    activity: "lick",
    description: "Lick or kiss the neck of the person to your left.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "dance",
    description:
      "Do a sexy dance for the person across from you for 15 seconds.",
    penaltyCost: 5,
  },

  {
    genre: "dare",
    activity: "phone",
    description: "Show the group your last search history or text message.",
    penaltyCost: 3,
    pub: true,
  },
  {
    genre: "dare",
    activity: "phone",
    description: "Text 'You up?' to the last person you flirted with.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Let the person 1 to the left take a photo of you making your best sexy pose, then they choose who to send it to.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Call a random contact and tell them you find them attractive.",
    penaltyCost: 5,
    pub: true,
  },
  {
    genre: "dare",
    activity: "drink",
    description: "Do a shot from the person 4 to the right's stomach.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Pretend to dirty talk with the person 2 to the left for 15 seconds.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Pick the person 6 to the right to spank you, or you spank them.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Reveal the most risqué photo in your phone, or let the person 3 to the left do it for you.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "dance",
    description: "Act like you're giving a strip tease for 20 seconds.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Take a suggestive selfie with the person 5 to the right and send it to the person of their choice.",
    penaltyCost: 4,
    pub: true,
  },
  {
    genre: "dare",
    activity: "kiss",
    description:
      "Blindfold yourself and let the person 6 to the left give you a surprise kiss somewhere on your body.",
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "draw",
    description:
      "Let the person 3 to the left draw a temporary tattoo on your arm with a marker.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Call someone and sing 'Happy Birthday' to them, even if it's not their birthday.",
    penaltyCost: 2,
    pub: true,
  },
  {
    genre: "dare",
    activity: "drink",
    description:
      "Take a shot of something that you really dislike (within reason).",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Let the person 4 to the right put makeup on you, blindfolded.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Let the group come up with a ridiculous nickname for you, and you must use it for the rest of the game.",
    pub: true,
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "drink",
    description:
      "Take a shot of a mixed drink created by the person 6 to the right (within reason).",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Pretend you're a runway model and do a 10-second walk in front of everyone.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "phone",
    description: "Call a friend and leave a voicemail singing a random song.",
    pub: true,
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description:
      "Let the group pick an outfit for you to wear for the next 5 minutes. Then remove all items again.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Pick a song and lip-sync it loudly for 30 seconds.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Try to balance a spoon on your nose for 30 seconds. If it falls, drink.",
    penaltyCost: 3,
    pub: true,
  },

  {
    genre: "dare",
    activity: "act",
    description:
      "Give the person 3 to the left a piggyback ride around the room for 1 minute.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Try to do a perfect impression of the person 5 to the right in the room for 30 seconds.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Text the person 1 to the left in your phone something funny or random.",
    pub: true,
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Have a staring contest with the person to your left. Loser drinks.",
    pub: true,
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Try to touch your toes for 30 seconds without falling over.",
    pub: true,
    penaltyCost: 1,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Pretend to be a professional chef and 'prepare' a meal for everyone (using pretend ingredients).",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Do your best impression of a baby crying for 15 seconds.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "dance",
    description: "Do a chicken dance for 30 seconds.",
    pub: true,
    penaltyCost: 1,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Make a funny face and hold it for 30 seconds.",
    pub: true,
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Do your best impression of a famous person for 30 seconds.",
    pub: true,
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Do 20 jumping jacks without stopping.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Recite the alphabet backward as quickly as you can. If you fail, drink.",
    pub: true,
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Lose an item of clothing of your choice.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Exchange pants with the person to your left.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Trade a piece of clothing with the person 4 to the right.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Wear socks on your hands",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Swap shirts with the person across from you.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "clothes",
    description:
      "Wear the anyones discarded top. (If none available then you drink)",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Let the person 6 to the right take a funny photo of you in a compromising pose and post it.",
    pub: true,
    penaltyCost: 5,
  },
  {
    genre: "dare",
    activity: "clothes",
    description:
      "Take off your socks and wear them as gloves for the next 5 minutes.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "phone",
    description:
      "Give your phone to the person 5 to the right and let them send a text to anyone in your contacts (with no explanation).",
    pub: true,
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "drink",
    description: "Swap drinks with the person to your left.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Wear a piece of clothing inside out for the next 10 minutes.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description:
      "Pick an item of clothing from the group and wear it for the rest of the round.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Do 10 jumping jacks and spin around after each one.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "clothes",
    description:
      "Let the person 4 to the right make you an outfit from anything they can find.",
    penaltyCost: 3,
  },

  {
    genre: "dare",
    activity: "dance",
    description: "Perform a freestyle dance for 30 seconds.",
    penaltyCost: 1,
  },
  {
    genre: "dare",
    activity: "phone",
    description: "Call or text your ex and say 'I miss you.'",
    pub: true,
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "phone",
    description: "Send the last person you hooked up with a suggestive emoji.",
    pub: true,
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "drink",
    description: "Choose the person 2 to the right to take a body shot off of.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "group",
    description:
      "Blindfolded, let the person 2 to the left in the group kiss or lick a part of your body (their choice).",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "clothes",
    description:
      "Swap an article of clothing with the person 4 to the right for the rest of the game.",
    penaltyCost: 3,
  },

  {
    genre: "dare",
    activity: "kiss",
    description: "Let everyone kiss or slap you. Their choice.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "kiss",
    description: "Give everyone a kiss.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "drink",
    description: "Take a shot with the person opposite you.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "drink",
    description: "Everyone takes a drink.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "drink",
    description: "Make a cocktail for the person on your right.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "group",
    description: "The group decides your next drink.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "group",
    description: "Let the group give you a makeover.",
    penaltyCost: 3,
  },
  {
    genre: "dare",
    activity: "group",
    description: "Group decides: Tell a joke or do a dance.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "eat",
    description: "Eat something without using your hands.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "dance",
    description: "Do your best twerk.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "dance",
    description: "Dance battle with the person to your right.",
    penaltyCost: 3,
  },

  {
    genre: "dare",
    activity: "act",
    description: "Stand up and sing loudly the national anthem.",
    penaltyCost: 4,
    pub: true,
  },

  {
    genre: "dare",
    activity: "act",
    description: "Do your best impression of a famous person for 30 seconds.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "dance",
    description: "Do your best robot dance for 30 seconds.",
    penaltyCost: 2,
  },
  {
    genre: "dare",
    activity: "act",
    description: "Play air guitar to an imaginary song.",
    penaltyCost: 2,
  },

  {
    genre: "dare",
    activity: "act",
    description: "Loudly sing 'Sweet Caroline'.",
    penaltyCost: 5,
    pub: true,
  },
  {
    genre: "dare",
    activity: "act",
    description:
      "Stand on your chair and give a dramatic 1-minute speech about why pineapple belongs on pizza.",
    penaltyCost: 5,
    pub: true,
  },

  {
    genre: "dare",
    activity: "act",
    description:
      "Guess the boobs. Close eyes, hands out. Guess who approches you.",
    penaltyCost: 5,
  },

  {
    genre: "dare",
    activity: "phone",
    description:
      "Call your parents and tell them you're getting married to someone they don't know.",
    penaltyCost: 4,
  },

  {
    genre: "dare",
    activity: "action",
    description:
      "Stand in the middle of the room and sing the national anthem in your best opera voice.",
    penaltyCost: 2,
  },

  {
    genre: "dare",
    activity: "action",
    description:
      "Do your best impression of a cat in heat for 30 seconds, including the sounds and movements.",
    penaltyCost: 3,
  },

  {
    genre: "dare",
    activity: "action",
    description:
      "Let the group blindfold you and feed you three mystery items from the kitchen. You must guess what each one is.",
    penaltyCost: 4,
  },

  {
    genre: "dare",
    activity: "action",
    description:
      "Wear all the clothes you can find in the room on top of your current outfit.",
    penaltyCost: 3,
  },

  {
    genre: "dare",
    activity: "action",
    description:
      "Create a 1-minute dance routine using only furniture as props. Perform it for the group.",
    penaltyCost: 3,
  },

  {
    genre: "dare",
    activity: "action",
    description:
      "Create a 30-second commercial for a random household item, using your most dramatic infomercial voice.",
    penaltyCost: 2,
  },

  {
    genre: "dare",
    activity: "clothes",
    description: "Remove an item of clothing from the person to your left.",
    penaltyCost: 2,
  },

  {
    genre: "dare",
    activity: "clothes",
    description: "Remove an item of clothing from the person to your right.",
    penaltyCost: 2,
  },

  {
    genre: "dare",
    activity: "clothes",
    description:
      "Remove an item of clothing from the person to your left using only your teeth.",
    penaltyCost: 4,
  },

  {
    genre: "dare",
    activity: "clothes",
    description:
      "Remove an item of clothing from the person to your right using only your teeth.",
    penaltyCost: 4,
  },
  {
    genre: "dare",
    activity: "clothes",
    description: "Undo the nearest trouser zip using only your teeth.",
    penaltyCost: 4,
  },

  {
    genre: "dare",
    activity: "act",
    description:
      "Put on lipstick. Kiss the person to your left on the cheek to leave a mark.",
    penaltyCost: 2,
  },
];
